import { BellIcon, CheckCircleIcon, EyeIcon, FolderOpenIcon, LockIcon, XCircleIcon } from '@phosphor-icons/react'

import { theme } from '@reveni-io/reveni-ui'

import { claimStatusValues } from '@/common/constants'

export const getClaimStatusChip = () => {
  return {
    [claimStatusValues.announce]: {
      label: 'Recibido',
      Icon: BellIcon,
      backgroundColor: theme.legacy.palette.blue.tone200,
      color: theme.legacy.colors.text.default,
    },
    [claimStatusValues.opened]: {
      label: 'Abierto',
      Icon: FolderOpenIcon,
      backgroundColor: theme.legacy.palette.blue.tone500,
      color: theme.legacy.palette.whiteAlpha.alpha100,
    },
    [claimStatusValues.inReview]: {
      label: 'En revisión',
      Icon: EyeIcon,
      backgroundColor: theme.legacy.palette.orange.tone400,
      color: theme.legacy.colors.text.default,
    },
    [claimStatusValues.approved]: {
      label: 'Aprobado',
      Icon: CheckCircleIcon,
      backgroundColor: theme.legacy.palette.teal.tone500,
      color: theme.legacy.colors.text.default,
    },
    [claimStatusValues.denied]: {
      label: 'Denegado',
      Icon: XCircleIcon,
      backgroundColor: theme.legacy.palette.red.tone500,
      color: theme.legacy.palette.whiteAlpha.alpha100,
    },
    [claimStatusValues.closed]: {
      label: 'Cerrado',
      Icon: LockIcon,
      backgroundColor: theme.legacy.palette.grey.tone800,
      color: theme.legacy.palette.whiteAlpha.alpha100,
    },
  }
}
